<div class="container">
    <div class="row gap-1h gap-lg-0 justify-content-lg-between gx-0">
        <div *ngFor="let card of cards" class="col-lg-auto">
            <a (click)="sendCardMenuDatalayer(card.titulo)" [href]="card.documentos[0].url" [attr.aria-label]="'Saiba mais sobre ' + card.documentos[0].titulo">
                <picture>
                    <source *ngFor="let objSrc of card.sources"
                        [media]="'(min-width: '+objSrc.minWidth+'px)'"
                        [type]="objSrc.typeImg"
                        [srcset]="objSrc.srcSets[0]">
                    <img src="data:image/png;base64, R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
                        [alt]="card.titulo" [title]="card.titulo" loading="lazy" width="230" height="217"
                        class="img-sanitize img-cover-width">
                </picture>
                <div class="title-text fs-25 text-primary mb-1h mb-lg-0">
                    {{card.titulo}}
                </div>
            </a>
        </div>
    </div>
</div>
